import service from "@/js/util/HttpUtils";


/**
 * 获取最新的开奖记录第一条
 * @param params
 * @param success
 * @param error
 */
export const lotteryRecordTopOne =function (params,success,error) {
    service.post("webApi/lotteryRecordTopOne", params, {
        successFun: success,
        errorFun: error
    })
}


export const lotteryRecordTopFour =function (params,success,error) {
    service.post("webApi/lotteryRecordTopFour", params, {
        successFun: success,
        errorFun: error
    })
}
export const lotteryRecordList =function (params,success,error) {
    service.post("webApi/lotteryRecordList", params, {
        successFun: success,
        errorFun: error
    })
}
export const thatDayPlaceBet =function (params,success,error) {
    service.post("webApi/thatDayPlaceBet", params, {
        successFun: success,
        errorFun: error
    })
}
export const addPlaceBet =function (params,success,error) {
    service.post("webApi/addPlaceBet", params, {
        successFun: success,
        errorFun: error
    })
}

export const getUserInfo =function (params,success,error) {
    service.post("webApi/getUserInfo", params, {
        successFun: success,
        errorFun: error
    })
}

// /**
//  * 删除未使用账号
//  * @param params
//  * @param success
//  * @param error
//  */
// export const deleteAccount =function (params,success,error) {
//     service.get("api/deleteAccount?id="+params.id, {
//         successFun: success,
//         errorFun: error
//     })
// }
// /**
//  * 导入文件
//  * @param params
//  * @param success
//  * @param error
//  */
// export const importAccount =function (params,success,error) {
//     service.post("api/importAccount", params, {
//         headers:{
//             'Content-Type':'multipart/form-data;'
//         },
//         successFun: success,
//         errorFun: error
//     })
// }
